import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const AdminPatientsLogs = withLazyFallback(() => import('components/admin/pages/Patients/Logs'));
const AdminPatientBasicInfo = withLazyFallback(
  () => import('components/admin/pages/Patients/PatientBasicInfo')
);
const AdminPatients = withLazyFallback(
  () => import('components/admin/pages/Patients/PatientsTable')
);
const AdminPatientsTransactions = withLazyFallback(
  () => import('components/admin/pages/Patients/Transaction/Transactions')
);
const AdminPatientPractices = withLazyFallback(
  () => import('components/admin/pages/Patients/Practices/Practices')
);
const PatientProfile = withLazyFallback(() => import('components/admin/pages/Patients/profile'));

const ADMIN_PATIENTS = [
  {
    path: 'patients',
    element: <AdminPatients />,
    handle: { title: 'Patients' },
    children: [
      {
        path: ':id',
        element: <PatientProfile />,
        children: [
          { path: '', element: <AdminPatientBasicInfo />, handle: { title: 'Overview' } },
          { path: 'practices', element: <AdminPatientPractices />, handle: { title: 'Practices' } },
          { path: 'logs', element: <AdminPatientsLogs />, handle: { title: 'Logs' } },
          {
            path: 'transactions',
            element: <AdminPatientsTransactions />,
            handle: { title: 'Transactions' }
          },
          { path: '*', element: <NotFound /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_PATIENTS;
